import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `EditDialogFieldDirective` represent a add dialog fields in VueJS Gantt.
 * It must be contained in a Gantt component(`GanttComponent`).
 * ```tsx
 * <GanttComponent dataSource={data} allowSelection={true} allowSorting={true}>
 * <EditDialogFieldsDirective>
 * <EditDialogFieldDirective type='General' headerText='General'></EditDialogFieldDirective>
 * <EditDialogFieldDirective type='Dependency' headerText='Dependency'></EditDialogFieldDirective>
 * </EditDialogFieldsDirective>
 * </GanttComponent>
 * ```
 */
export class EditDialogFieldDirective extends ComplexBase {
}
EditDialogFieldDirective.moduleName = 'editDialogField';
export class EditDialogFieldsDirective extends ComplexBase {
}
EditDialogFieldsDirective.propertyName = 'editDialogFields';
EditDialogFieldsDirective.moduleName = 'editDialogFields';
